var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("支付总金额："+_vm._s(_vm.settlementResult.sum)+" 元")]),_vm._v(" "),_c('Table',{attrs:{"stripe":"","columns":_vm.columns,"data":_vm.settlementResult.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c608c4e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/order/order_detail/pay-detail.vue
// module id = Aouq
// module chunks = 0